/*
 * @Author: Michael 
 * @Date: 2019-03-13 11:15:52 
 * @Last Modified by: Michael
 * @Last Modified time: 2019-03-13 11:19:38
 * 获取素材库材料
 */

import getUrlParam from '@/common/utils/getUrlParam';
import fetch from '@/common/api/fetch';
import { AxiosPromiseData } from '@/common/interface';
import store from '@/store';

export default function getMetarialData() {
  const param = { instId: getUrlParam('instId') || store.state.instId };
  fetch.Sales('anon/businessShow/getMaterial', param).then((materialRes: AxiosPromiseData) => {
    const { result } = materialRes;
    const { status } = result;
    // 判断是否应用了小麦活动
    if (status !== 1) {
      store.dispatch("changeMaterialStatus", false);
    } else {
      if (getUrlParam('broadcastId')) {
        return;
      }
      let { carousel, contact, instName, instPhone, introduction} = result;
      if (carousel) {
        carousel = JSON.parse(carousel);
      } else {
        carousel = [];
      }
      contact = JSON.parse(contact);
      introduction = JSON.parse(introduction);

      if (carousel.length > 0) {
        carousel.forEach((item: string, index: number) => {
          store.dispatch('changeGroupImageList', { value: item, index });
        });
      }
      if (contact.contact) {
        store.dispatch('changeContactInfo', { contactInfo: contact.contact });
      }
      if (contact.qrcode) {
        store.dispatch('changeContactQrcode', contact.qrcode);
      }
      if (instName) {
        store.dispatch('changeInstName', { instName });
      }
      if (instPhone) {
        store.dispatch('changeInstPhone', instPhone);
      }
      if (introduction.length > 0) {
        store.dispatch('deleteInstitutionIntro', 0);
        introduction.forEach((item: any) => {
          store.dispatch('addInstitutionintro', { item });
        })
      }
    }
  })
}
